import React from 'react';
import styled from 'styled-components';

import BasicCardTop from './BasicCardTop';

import theme from '@styles/theme';


const WhiteLogoCardWrapper = styled(BasicCardTop)`
    background-color: ${(props) => theme.accents[props.index] || theme.accents[Math.floor(Math.random() * 4)]};

    img {
        object-fit: contain;
        max-width: 200px;
        align-self: center;
    }
`
 
const WhiteLogoCardTop = ({ cardImage, index }) => {{
    return (
        <WhiteLogoCardWrapper cardImage={cardImage} index={index} />
    )
}}
 
export default WhiteLogoCardTop